module.exports = function getResource(label, vars = []) {
    let resources = {
        //Main component
        nextButtonLabel: 'Next',
        previousButtonLabel: 'Previous',

        //GetStarted component
        welcomeMessage: 'Welcome to',
        getStartedButtonLabel: 'Get Started',

        //Error component
        playSubscriptionErrorMessage: 'This page is exclusively for PLAY! by Sephora subscribers.',
        playJoinMessage: 'To join, please visit',
        connectionErrorMessage: 'Sorry, there seems to be a connection issue.',
        tryAgainMessage: 'Please try again.',

        //Constants
        skinType: 'What is your *skin type?*',
        skinTone: 'What is your *skin tone?*',
        skincare: 'What are your *skin care concerns?*',
        hairColor: 'What is your *hair color?*',
        hairDescrible: 'How would you describe your *hair?*',
        hairConcerns: 'What are your *hair concerns?*',
        eyeColor: 'What is your *eye color?*',
        beautyHabitsAgreement: 'Below is a list of statements that might reflect your attitudes about beauty.',
        skincareDirection: 'Choose all that apply.',
        hairDescribleDirection: 'Choose all that apply.',
        hairConcernsDirection: 'Choose all that apply.',
        beautyHabitsAgreementDirection: 'Please tell us how much you agree or disagree with these statements.',
        skinCategory: 'Skin',
        hairCategory: 'Hair',
        eyesCategory: 'Eyes',
        preferencesCategory: 'Preferences'
    };

    return resources[label];
};
